// extracted by mini-css-extract-plugin
export var tag = "Tag-module--tag--3NkJ9";
export var tagBtn = "Tag-module--tag-btn--1c3rG";